/**
 * {@link} https://angular-maps.com/api-docs/agm-core/components/agmmap
 */
export const MAP_CONFIG: any = {
  maxZoom: 17,
};
